import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const Container = styled(Box)<{ color?: string }>`
	background-size: cover;
	background-position: center;
	position: relative;
	height: 100%;
	background-image: unset;
	display: grid;
	grid-template-rows: 19em auto;
	background-color: ${(props) => props.color || "#0184a4"};

	&.portrait {
		background-position: top;
		background-size: cover;
	}

	.info-icon:hover {
		circle {
			fill: #0184a4;
		}
	}
`;

export const Head = styled(Box)<{ image: string }>`
	position: relative;
	align-items: center;
	background-repeat: no-repeat;
	background-position: center center;
	background-size: cover;
	background-image: url(${(props) => props.image});

	> div:nth-of-type(1) {
		position: absolute;
		bottom: 1em;
		right: 1em;
	}
`;

export const Body = styled(Box)<{ eventended: number }>`
	padding: ${(props) => (props.eventended ? "0" : "0 1.5em")};
`;
